import React from 'react';
import { AdminLayout } from '../components/AdminLayout';
import { AIChatPanel } from '../../../chat/components/AIChatPanel';

export const AdminAIChatPage: React.FC = () => (
  <AdminLayout>
    <div style={{ height: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column' }}>
      <div style={{ padding: '16px 24px 8px', borderBottom: '1px solid #e5e7eb' }}>
        <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#111827' }}>
          AI Assistant
        </h1>
        <p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>
          Ask questions about the full portfolio using AI-powered tools
        </p>
      </div>
      <div style={{ flex: 1, overflow: 'hidden' }}>
        <AIChatPanel />
      </div>
    </div>
  </AdminLayout>
);
